export function initSlide(target: HTMLElement) {

    // required to be recognized as a slide...
    target.classList.add("ws-frame");
}